<template>
    <main class="register-confirm">
        <div class="container">
            <Header
                title="¿Olvidaste tu clave?"
                text="No te preocupes, puedes recuperarla ingresando tu correo."
            />
            <CardMessage
                title="Solicitud Enviada"
                message="Hemos enviado a tu correo una solicitud con un link de recuperación de contraseña."
                info="Si no se visualiza el correo en tu casilla de entrada revisa en tu carpeta de spam."
            />
        </div>
    </main>
</template>

<script>
import Header from "@/components/signupAndLogin/Header";
import CardMessage from "@/components/signupAndLogin/CardMessage";

export default {
    name: "RecoveryConfirm",
    components: {
        Header,
        CardMessage,
    },
};
</script>
